export function formatGermanNumber(
  value: number | string | null | undefined
): string {
  const num = Number(value);
  if (value == null || isNaN(num)) return "0,00";

  return num.toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatEuroDe(value: number): string {
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
